export default "__VITE_ASSET__CqoLSjqQ__"